import { render, staticRenderFns } from "./keyboard-shortcut-helper.vue?vue&type=template&id=f4d87e5e&scoped=true&"
import script from "./keyboard-shortcut-helper.vue?vue&type=script&lang=js&"
export * from "./keyboard-shortcut-helper.vue?vue&type=script&lang=js&"
import style0 from "./keyboard-shortcut-helper.vue?vue&type=style&index=0&id=f4d87e5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d87e5e",
  null
  
)

export default component.exports